import { Shield, CheckCircle2, Clock, Phone } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";

export default function Cotacao() {
  return (
    <div data-testid="cotacao-page">
      {/* Hero */}
      <section className="pt-20 bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-5">
            <Shield className="h-4 w-4 text-gold" />
            <span className="text-sm text-white/80 font-medium">Cotação Online</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white leading-tight mb-4">
            Solicite sua <span className="text-gold">cotação gratuita</span>
          </h1>
          <p className="text-base md:text-lg text-slate-300 max-w-2xl mx-auto">
            Preencha o formulário abaixo e receba uma proposta personalizada. Comparamos as melhores opções de mais de 10 seguradoras.
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Form */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl border border-slate-200 p-6 md:p-10 shadow-sm">
                <h2 className="font-heading font-bold text-navy text-2xl mb-2">Dados para cotação</h2>
                <p className="text-sm text-slate-500 mb-8">Campos marcados com * são obrigatórios.</p>
                <QuoteForm />
              </div>
            </div>

            {/* Side info */}
            <div className="lg:col-span-2 space-y-6">
              <div className="bg-slate-50 rounded-xl border p-6">
                <h3 className="font-heading font-semibold text-navy mb-4">Como funciona</h3>
                <ol className="space-y-4">
                  {[
                    { step: "1", text: "Preencha o formulário com seus dados" },
                    { step: "2", text: "Comparamos opções entre as seguradoras" },
                    { step: "3", text: "Receba sua proposta personalizada" },
                    { step: "4", text: "Escolha a melhor opção para você" },
                  ].map((item) => (
                    <li key={item.step} className="flex items-start gap-3">
                      <span className="w-7 h-7 rounded-full bg-brand text-white text-sm font-bold flex items-center justify-center shrink-0">{item.step}</span>
                      <span className="text-sm text-slate-600 pt-0.5">{item.text}</span>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="bg-slate-50 rounded-xl border p-6">
                <h3 className="font-heading font-semibold text-navy mb-3">Atendimento rápido</h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-2.5 text-sm text-slate-600">
                    <Clock className="h-4 w-4 text-gold shrink-0" /> Resposta em minutos
                  </li>
                  <li className="flex items-center gap-2.5 text-sm text-slate-600">
                    <CheckCircle2 className="h-4 w-4 text-gold shrink-0" /> Cotação 100% gratuita
                  </li>
                  <li className="flex items-center gap-2.5 text-sm text-slate-600">
                    <Phone className="h-4 w-4 text-gold shrink-0" /> Suporte por WhatsApp
                  </li>
                </ul>
              </div>

              <div className="bg-navy rounded-xl p-6 text-center">
                <p className="text-white font-heading font-semibold mb-2">Prefere falar direto?</p>
                <p className="text-slate-300 text-sm mb-4">Ligue ou mande mensagem:</p>
                <div className="space-y-2">
                  <a href="tel:+553125550207" className="block text-gold font-medium text-sm hover:underline">MG: (31) 2555-0207</a>
                  <a href="tel:+5562999642435" className="block text-gold font-medium text-sm hover:underline">GO/DF: (62) 99964-2435</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
